import {Component} from "@angular/core";
import {Router} from "@angular/router";
import {TourApplication} from "../../service/tour-application/tour-application";


@Component({
  selector: 'app-tour-list',
  templateUrl: 'tour-list.component.html',
  styleUrls: ['tour-list.component.scss'],
})
export class TourListComponent {
  applications: TourApplication[];

  timeValues = {
    TEN: { value: 10, text:'10:00~11:00'},
    TEN_HALF: { value: 10.5, text:'10:30~11:30'},
    ELEVEN: { value: 11, text:'11:00~12:00'},
    ELEVEN_HALF: { value: 11.5, text:'11:30~12:30'},
    FOURTEEN: { value: 14, text:'14:00~13:00'},
    FOURTEEN_HALF: { value: 14.5, text:'14:30~15:30'},
    FIFTEEN: { value: 15, text:'15:00~16:00'},
    FIFTEEN_HALF: { value: 15.5, text:'15:30~16:30'},
    SIXTEEN: { value: 16, text:'16:00~17:00'},
    SIXTEEN_HALF: { value: 16.5, text:'16:30~17:30'},
  };

  constructor(private router: Router) {
    this.applications = [];

    let cache = JSON.parse(sessionStorage.getItem('__hey_tourList'));
    if(cache) {
      this.applications = cache.filter(o => o.status !== 'CANCLE');
    } else {
      this.router.navigate(['/tour/lookup'])
    }
  }

  setDetail(application: TourApplication) {
    sessionStorage.setItem('__hey_tourDetail', JSON.stringify(application));
  }
}



// WEBPACK FOOTER //
// ./src/app/space/tour-list/tour-list.component.ts